import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { DISPLAY, Container, Truck, Store, WhatsApp, WHATSAPP_DISPLAY, WHATSAPP_URL } from '../components/home/ui';
import { Card, CardHead, pbtn, gbtn } from '../components/account/shared';

// Sucursales (diseño sucursales.html): hoy la tienda es solo en línea. Los
// textos, tiempos y costos son los del diseño.

const ClockIcon = (p) => (
    <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
);
const TagIcon = (p) => (
    <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
);

const ZONAS = [
    ['Ciudad de Guatemala', '24 – 48 h', 'Q25'],
    ['Mixco, Villa Nueva, San Miguel Petapa', '24 – 48 h', 'Q30'],
    ['Antigua Guatemala', '1 – 2 días', 'Q35'],
    ['Resto de departamentos', '2 – 4 días hábiles', 'Q45'],
];
const OPCIONES_ZONA = ['Ciudad de Guatemala', 'Mixco / Villa Nueva', 'Antigua Guatemala', 'Quetzaltenango', 'Otro departamento'];

const FAQ = [
    ['¿Puedo recoger mi pedido en algún lugar?', 'Por el momento no tenemos punto de entrega. Todos los pedidos se envían a la dirección que indiques al comprar.'],
    ['¿Puedo pagar contra entrega?', 'Sí. Por ahora los pedidos en línea se pagan contra entrega.'],
    ['¿Cómo sé dónde va mi pedido?', <>Puedes consultarlo en <Link to='/rastrear' className='text-[#0891b2] font-bold'>Rastrea tu pedido</Link> o en Mis pedidos, dentro de tu cuenta.</>],
    ['¿Qué pasa si el producto no le gusta a mi mascota?', 'Tienes 30 días para cambios y devoluciones. Escríbenos y coordinamos la recolección.'],
];

const Sucursales = () => {
    const [email, setEmail] = useState('');
    const [zona, setZona] = useState('');

    // No hay dónde guardar el aviso en el sistema: se arma el mensaje y se
    // abre WhatsApp, para que el aviso llegue de verdad.
    const avisar = (e) => {
        e.preventDefault();
        const msg = `Hola, me gustaría que me avisen cuando abran una tienda física en ${zona}. Mi correo: ${email}`;
        window.open(`${WHATSAPP_URL}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='w-full bg-white'>
            <Header />
            <div className='bg-[#faf9f6] pt-8 pb-20 border-t border-[#f1efea]'>
                <Container>
                    <nav className='pb-[14px] text-[13px] text-[#64748b] flex gap-2 items-center' aria-label='Ruta'>
                        <Link to='/' className='hover:text-[#0891b2]'>Inicio</Link><span>/</span><span className='text-[#0f172a] font-semibold'>Sucursales</span>
                    </nav>

                    <div className='grid grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] md-lg:grid-cols-1 gap-10 items-center bg-white border border-[#f1efea] rounded-[28px] p-12 md-lg:p-8 sm:p-6 overflow-hidden'>
                        <div>
                            <span className='inline-flex items-center gap-2 bg-[#ecfeff] text-[#0e7490] px-[14px] py-[7px] rounded-full text-[12px] font-extrabold tracking-[.06em] uppercase'>
                                <Store className='w-[14px] h-[14px]' />Tienda 100% en línea
                            </span>
                            <h1 className='text-[#1e3a8a] font-bold leading-[1.04] tracking-[-.02em] mt-4 mb-[14px]' style={{ ...DISPLAY, fontSize: 'clamp(32px, 4vw, 50px)', textWrap: 'balance' }}>
                                Por ahora no tenemos tienda física. <em className='not-italic text-[#0891b2]'>Llevamos todo a tu casa.</em>
                            </h1>
                            <p className='text-[16.5px] text-[#334155] mt-0 mb-[26px] max-w-[480px] leading-[1.6]'>
                                Compra en línea y recibe en cualquier parte de Guatemala. Si tienes dudas antes de comprar, te atendemos por WhatsApp o por el chat de tu cuenta.
                            </p>
                            <div className='flex gap-[10px] flex-wrap'>
                                <Link to='/shops' className={pbtn}>Ir a la tienda</Link>
                                <a href={WHATSAPP_URL} target='_blank' rel='noopener noreferrer' className={`${gbtn} !h-[50px]`}><WhatsApp className='w-4 h-4' />Escríbenos por WhatsApp</a>
                            </div>
                        </div>
                        <div className='rounded-[22px] overflow-hidden grid place-items-center' style={{ aspectRatio: '4 / 3', background: 'linear-gradient(135deg, #cffafe 0%, #ecfeff 50%, #e0e7ff 100%)' }}>
                            <div className='text-center'>
                                <div className='text-[88px] leading-none' aria-hidden='true'>📦</div>
                                <div className='mt-3 inline-flex items-center gap-2 bg-white rounded-[14px] px-[14px] py-[10px] text-[13px] font-bold text-[#0f172a] shadow-[0_12px_30px_-8px_rgba(0,0,0,.18)]'>
                                    <Truck className='w-4 h-4 text-[#0891b2]' />Envíos a todo el país
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='grid grid-cols-3 md-lg:grid-cols-1 gap-[14px] my-[14px]'>
                        {[
                            [Truck, 'bg-[#ecfeff] text-[#0891b2]', 'Envío a todo el país', '24 a 48 horas en la capital y de 2 a 4 días hábiles en los departamentos.'],
                            [TagIcon, 'bg-[#dcfce7] text-[#15803d]', 'Envío gratis desde Q899', 'En compras menores el envío cuesta desde Q25, según tu zona.'],
                            [ClockIcon, 'bg-[#fef3c7] text-[#b45309]', 'Atención de 9:00 a 21:00', `Todos los días por WhatsApp al ${WHATSAPP_DISPLAY} o desde el chat de tu cuenta.`],
                        ].map(([Icon, tone, t, s]) => (
                            <Card key={t}>
                                <div className={`w-[46px] h-[46px] rounded-[14px] grid place-items-center mb-[14px] ${tone}`}><Icon className='w-[22px] h-[22px]' /></div>
                                <h3 className='text-[#1e3a8a] text-[18px] font-bold mt-0 mb-[6px]' style={DISPLAY}>{t}</h3>
                                <p className='m-0 text-[14px] text-[#334155] leading-[1.55]'>{s}</p>
                            </Card>
                        ))}
                    </div>

                    <div className='grid grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] md-lg:grid-cols-1 gap-[14px]'>
                        <Card>
                            <CardHead title='Tiempos y costos de envío' />
                            <div className='overflow-x-auto'>
                                <table className='w-full text-[14px] border-collapse'>
                                    <thead>
                                        <tr className='text-[11.5px] uppercase tracking-[.05em] text-[#64748b]'>
                                            <th className='text-left font-semibold pb-3 border-b border-[#f1efea]'>Zona</th>
                                            <th className='text-left font-semibold pb-3 border-b border-[#f1efea]'>Tiempo</th>
                                            <th className='text-right font-semibold pb-3 border-b border-[#f1efea]'>Costo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ZONAS.map(([z, t, c]) => (
                                            <tr key={z} className='border-b border-[#f1efea] last:border-b-0'>
                                                <td className='py-3 pr-3 font-bold text-[#0f172a]'>{z}</td>
                                                <td className='py-3 pr-3 text-[#334155] whitespace-nowrap'>{t}</td>
                                                <td className='py-3 text-right font-bold text-[#0f172a]'>{c}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <p className='mt-[14px] mb-0 text-[13px] text-[#64748b]'>En compras desde Q899 el envío es gratis en todas las zonas.</p>
                        </Card>

                        <div className='rounded-[20px] p-6 text-white' style={{ background: 'linear-gradient(135deg, #1e3a8a, #0891b2)' }}>
                            <h3 className='text-[22px] font-bold mt-0 mb-[6px]' style={DISPLAY}>¿Te gustaría una tienda cerca?</h3>
                            <p className='mt-0 mb-[18px] text-[14.5px] text-white/85'>Déjanos tu zona y te avisamos cuando abramos la primera tienda física.</p>
                            <form onSubmit={avisar} className='flex flex-col gap-[10px]'>
                                <input type='email' required value={email} onChange={e => setEmail(e.target.value)} placeholder='tu@correo.com' aria-label='Correo electrónico'
                                    className='h-12 rounded-[12px] border-none px-[14px] text-[15px] outline-none text-[#0f172a]' />
                                <select required value={zona} onChange={e => setZona(e.target.value)} aria-label='Tu zona'
                                    className='h-12 rounded-[12px] border-none px-[14px] text-[15px] outline-none text-[#0f172a] bg-white'>
                                    <option value=''>Elige tu zona</option>
                                    {OPCIONES_ZONA.map(z => <option key={z}>{z}</option>)}
                                </select>
                                <button className='h-12 rounded-[12px] bg-[#f87171] hover:bg-[#ef4444] text-white font-bold text-[15px] inline-flex items-center justify-center gap-2'>
                                    <WhatsApp className='w-4 h-4' />Avísame por WhatsApp
                                </button>
                            </form>
                        </div>
                    </div>

                    <Card className='mt-[14px]'>
                        <CardHead title='Preguntas frecuentes' />
                        {FAQ.map(([q, a], i) => (
                            <details key={q} open={i === 0} className='group border-b border-[#f1efea] last:border-b-0 py-4'>
                                <summary className='cursor-pointer font-bold text-[#0f172a] text-[15px] list-none flex justify-between gap-3 [&::-webkit-details-marker]:hidden'>
                                    {q}
                                    <span className='text-[20px] text-[#0891b2] leading-none group-open:hidden'>+</span>
                                    <span className='text-[20px] text-[#0891b2] leading-none hidden group-open:inline'>−</span>
                                </summary>
                                <p className='mt-[10px] mb-0 text-[14.5px] text-[#334155] leading-[1.6] max-w-[760px]'>{a}</p>
                            </details>
                        ))}
                    </Card>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default Sucursales;
